// extracted by mini-css-extract-plugin
module.exports = {"accordion":"locations_accordion__xoUGe","accordionContent":"locations_accordionContent__t4IiY","trigger":"locations_trigger__A0yky","link":"locations_link__pnorB"};